import React from 'react';
import { Paper, Typography, Divider, Box, RadioGroup, FormControlLabel, Radio, FormGroup, Checkbox, TextField } from '@mui/material';

const SchemaPreview = ({ sections }) => {
  if (!sections) return null;

  return sections.map((section, sIdx) => (
    <Paper key={sIdx} variant="outlined" sx={{ mb: 4, p: 3, borderRadius: 3, bgcolor: '#fafafa' }}>
      <Typography variant="subtitle1" color="primary" fontWeight="700" mb={1} sx={{ textTransform: 'uppercase' }}>
        {section.section_title}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      {section.questions.map((q) => (
        <Box key={q.id} sx={{ mb: 4 }}>
          <Typography variant="body1" fontWeight="600" mb={1}>{q.question_text}</Typography>
          {q.type === 'single_choice' && (
            <RadioGroup row>
              {q.options?.map((opt) => (
                <FormControlLabel key={opt} value={opt} control={<Radio size="small" />} label={<Typography variant="body2">{opt}</Typography>} disabled />
              ))}
            </RadioGroup>
          )}
          {q.type === 'multiple_choice' && (
            <FormGroup row>
              {q.options?.map((opt) => (
                <FormControlLabel key={opt} control={<Checkbox size="small" />} label={<Typography variant="body2">{opt}</Typography>} disabled />
              ))}
            </FormGroup>
          )}
          {q.type === 'text_area' && (
            <TextField fullWidth multiline rows={2} variant="outlined" size="small" disabled sx={{ bgcolor: '#fff' }} />
          )}
        </Box>
      ))}
    </Paper>
  ));
};

export default SchemaPreview;